/* eslint-disable indent */
import { getArtworksFromArtist } from 'api/artworks'
import { ArtworkCard } from 'components/artwork/ArtworkCard'
import { Carousel } from 'components/carousels/Carousel'
import useTranslation from 'next-translate/useTranslation'
import { useQuery } from 'react-query'
import { range } from 'utils/arrays'
import { Artist, mapIArtworksToArtworkCards } from 'utils/data'
import { getArtistUrl } from 'utils/urls'

type Props = {
  artists: Artist[]
  id: number
}

export function MoreFromArtistCarousel({ artists, id }: Props) {
  const { t } = useTranslation()

  const { data: artworks = [], isFetchedAfterMount } = useQuery(
    ['artworks', id],
    async () => {
      if (!id) return []

      const artworksData = await getArtworksFromArtist(id, artists[0].id)

      return mapIArtworksToArtworkCards(artworksData.data)
    },
    {
      enabled: Boolean(id),
      refetchOnWindowFocus: false,
    }
  )

  if (isFetchedAfterMount && !artworks.length) return null

  return (
    <Carousel
      title={
        artists.length === 1
          ? t('single_artwork:more_from_artist_name', {
              artistName: artists?.[0]?.name,
            })
          : t('single_artwork:more_from_artists')
      }
      className='bg-cool-50 pb-6 pt-8 sm:px-6 md:px-0 lg:pb-8 lg:pt-12'
      viewAllHref={
        artists?.[0]?.name && artists?.[0]?.id
          ? getArtistUrl(artists[0].name, artists[0].id)
          : '#'
      }
      viewAllLabel={t('common:view_all')}
    >
      {!isFetchedAfterMount && range(0, 6).map(i => <ArtworkCard key={i} />)}

      {artworks.map((artwork, index) => (
        <ArtworkCard key={index} {...artwork} />
      ))}
    </Carousel>
  )
}
